import { Box } from 'grommet'
import styled from 'styled-components'

export const ExperienceSectionWrapper = styled(Box)`
  position: relative;

  .title {
    height: ${({ theme }) => theme.spaces[5]}px;

    ${({ theme }) => theme.below.mobileL`
      text-align: left;
      padding-left: 4vw;
    `}
  }

  .subtitle {
    margin-top: ${({ theme }) => theme.spaces[0]}px;
  }

  .image-wrapper {
    margin-bottom: ${({ theme }) => theme.spaces[3]}px;
  }

  .additional-hexagon {
    left: ${({ theme }) => theme.spaces[0]}px;
    position: absolute;
    top: -${({ theme }) => theme.spaces[2] + theme.spaces[3]}px;
    ${({ theme }) => theme.below.laptop`
      display: none;
    `}
  }

  .description-title {
    ${({ theme }) => theme.below.tablet`
      line-height: normal;
    `}
  }
`

export const TitleWrapper = styled.span`
  background-clip: padding-box;
  background-color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => theme.global.borderSize.xsmall} solid transparent;
  border-radius: 6px;
  padding: ${({ theme }) => theme.spaces[1]}px;
  position: relative;

  ${({ theme }) => theme.below.mobileL`
    padding: 0 ${theme.spaces[1]}px;
  `}

  &:before {
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.lightOrange},
      ${({ theme }) => theme.colors.secondary}
    );
    border-radius: inherit;
    bottom: ${({ theme }) => theme.spaces[0]}px;
    content: '';
    left: ${({ theme }) => theme.spaces[0]}px;
    margin: -1px;
    position: absolute;
    right: ${({ theme }) => theme.spaces[0]}px;
    top: ${({ theme }) => theme.spaces[0]}px;
    z-index: -100;
  }
`
